import * as Yup from "yup";

export const validationLogin = Yup.object().shape({
	user: Yup.string().required("El nombre de usuario es obligatorio"),
	password: Yup.string().min(6, "La contraseña debe tener al menos 6 caracteres").required("La contraseña es obligatoria"),
});

export const emailValidation = Yup.object().shape({
	email: Yup.string().email("El formato del correo es incorrecto").required("El correo electrónico es obligatorio"),
});

export const Restorepassword = Yup.object({
	password: Yup.string().required("La contraseña es obligatoria").min(8, "La contraseña debe tener al menos 8 caracteres"),
	passwordRepeat: Yup.string().oneOf([Yup.ref("password"), null], "Las contraseñas deben ser iguales"),
});
